module.exports = __webpack_public_path__ + "static/media/flairLogo.9da8c33b.png";